import { useMemo } from "react";
import { useSelector } from "react-redux";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Autocomplete, AutocompleteAPI, Box, FormField, RadioGroup, Typography } from "@maysoft/common-component-react";

import Strings from "constants/strings";
import useDataCommon from "hooks/useDataCommon.hook";

import { RootState } from "store";
import { Mode, Status } from "constants/enum";
import { ICodename, IDataDetailReport, IErrorReport } from "commons/interfaces";


const CardPatientInfo = ({
    mode,
    data,
    error,
    dataOptions,
    handleChangeValue,
}: {
    mode: Mode,
    error: IErrorReport;
    data: IDataDetailReport;
    handleChangeValue: (key: string, value: any) => void;
    dataOptions: {
        groups: ICodename[];
        gender: ICodename[];
    };
}) => {

    const { getDataDepartments } = useDataCommon();

    const workingOrganization = useSelector((state: RootState) => state.user.workingOrganization);

    const requestGetApiGroup = useMemo(() => ({
        listStatus: [Status.Active],
        organizationId: workingOrganization || "0",
    }), [workingOrganization]);

    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.REPORT.PATIENT_INFORMATION}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.REPORT.FULL_NAME}
                        defaultValue={data?.objectName || ""}
                        errorMessage={error?.objectName || ""}
                        placeholder={Strings.REPORT.ENTER_FULL_NAME}
                        onBlur={(value) => {
                            handleChangeValue("objectName", value);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.REPORT.BIRTHDAY}
                        defaultValue={data?.objectBirthday || ""}
                        errorMessage={error?.objectBirthday || ""}
                        placeholder={Strings.REPORT.ENTER_BIRTHDAY}
                        onBlur={(value) => {
                            handleChangeValue("objectBirthday", value);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Box sx={{ gap: 1, display: "flex", flexWrap: "wrap", alignItems: "center" }}>
                        <Typography variant="button" sx={{ fontSize: "0.785rem", lineHeight: 1.5 }} color="secondary">
                            {Strings.REPORT.GENDER}:
                        </Typography>
                        <RadioGroup
                            isRow
                            label={""}
                            disabled={mode === Mode.View}
                            dataMulti={dataOptions.gender}
                            value={`${data?.objectGender}`}
                            onChangeValue={(value) => {
                                handleChangeValue("objectGender", Number(value));
                            }}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.REPORT.MEDICAL_RECORD_NO}
                        defaultValue={data?.objectMedicalRecordNo || ""}
                        errorMessage={error?.objectMedicalRecordNo || ""}
                        placeholder={Strings.REPORT.ENTER_MEDICAL_RECORD_NO}
                        onBlur={(value) => {
                            handleChangeValue("objectMedicalRecordNo", value);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.groups}
                        label={Strings.REPORT.DEPARTMENT}
                        defaultValue={data?.objectDepartment}
                        errorMessage={error?.objectDepartment}
                        placeholder={Strings.REPORT.SELECT_DEPARTMENT}
                        onChange={(value) => {
                            handleChangeValue("objectDepartment", value);
                        }}
                    />
                    {/* <AutocompleteAPI
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.REPORT.DEPARTMENT}
                        defaultValue={data?.objectDepartment}
                        errorMessage={error?.objectDepartment}
                        placeholder={Strings.REPORT.SELECT_DEPARTMENT}
                        getApi={getDataDepartments}
                        requestGetApi={requestGetApiGroup}
                        dataSelected={data?.objectDepartment ? [{
                            code: data?.objectDepartment || "",
                            name: data?.objectDepartmentName || "",
                        }] : []}
                        onChange={(value) => { }}
                        onChangeItem={(value) => {
                            handleChangeValue("objectDepartment", value);
                        }}
                    /> */}
                </Grid>
            </Grid>
        </Card>
    );
}

export default CardPatientInfo;